// import {core} from 'x.core';
// class Header extends core.Controller {
class Choice extends BX.X.core.Controller {

    init () 
    {
        this.nodes = {
                aetec: false,
                planks: false,
                vent: false
            };

        // инициализация элементов
        this.nodes.aetec = this.node.querySelector('.role-aetec');
        this.nodes.planks = this.node.querySelector('.role-planks');
        this.nodes.vent = this.node.querySelector('.role-vent');

    }


    setTile (TileId)
    {

        if (this.nodes.aetec) this.nodes.aetec.innerHTML = '';
        if (this.nodes.planks) this.nodes.planks.innerHTML = '';
        if (this.nodes.vent) this.nodes.vent.innerHTML = '';

        BX.X.ajax.runAction('x:api.interface.bundle.include', {
                method: 'POST',
                data:{
                    refParams: {
                        aetec: {name: 'aetec', template: '.default', params: {ID:TileId}},
                        planks: {name: 'planks', template: '.default', params: {ID:TileId}},
                        vent: {name: 'vent', template: '.default', params: {ID:TileId}},
                    }
                }
            },3600).then((response) => {
                if (response.data.aetec && this.nodes.aetec) this.nodes.aetec.innerHTML = response.data.aetec;
                if (response.data.planks && this.nodes.planks) this.nodes.planks.innerHTML = response.data.planks;
                if (response.data.vent && this.nodes.vent) this.nodes.vent.innerHTML = response.data.vent;
                BX.onCustomEvent('x.vue.loader:initVue');
            }, (response) => {
                
            });
    }
}

export {Choice};